import { z } from "zod";
//#region src/api/orpc/shared/localizedString.ts
/**
* Localized string payload — `{ en?, zh?, ja?, ko? }`.
*
* Canonical home: contracts surfacing localized text (e.g. contest titles
* on artwork cards) and server-side validation both import from here.
* `pixai-server/zodSchema/contestV2.ts` re-exports these symbols so the
* Prisma JSONB type alias chain (`ZodSchema.LocalizedString`) stays intact.
*
* All locales are optional; callers are responsible for picking a
* non-empty value at display time.
*/
const localizedStringSchema = z.object({
	en: z.string().optional(),
	zh: z.string().optional(),
	ja: z.string().optional(),
	ko: z.string().optional()
});
//#endregion
export { localizedStringSchema };
